import { type FC } from 'react';
import {
  PencilSimple
} from '@phosphor-icons/react';
import { UiIcon, type UiIconProps } from './UiIcon';

export type UiIconPencilSimpleProps = Omit<UiIconProps, 'IconComponent'>;

export const UiIconPencilSimple: FC<UiIconPencilSimpleProps> = (props) => {
  return (
    <UiIcon
      IconComponent={PencilSimple}
      {...props}
    />
  );
};
